import { isIOS } from "../../utils/platformUtils"
import React, { useEffect, useState, useMemo } from 'react'
import {
    StyleSheet,
    Text,
    View,
    TextInput,
    ScrollView,
    Keyboard,
    TouchableWithoutFeedback,
    TouchableOpacity,
    Switch,
    Dimensions,
} from 'react-native'
import theme from '../../../theme'
import { useForm } from './hooks/useForms'
import { SelectList } from 'react-native-dropdown-select-list'
import { Feather } from '@expo/vector-icons'
import { useNavigation } from '@react-navigation/native'

import { useCreatePos } from './hooks/useCreatePos'
import { schedulesServices } from '../../../database/schedules.database'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { Loader } from '../customUtils/Components/Loader'
import { request_get_address } from '../../services/schedule.services'
import { fetchAuthSession } from 'aws-amplify/auth'
import { eventEmitter, validateConnectionNetwork } from '../../utils/functions.utils'

export const CREATE_STORE_INPUTS_TYPES = {
    TEXT: 'text',
    DROPDOWN: 'dropdown',
    NUMBER: 'number',
} as const

export type CreateStoreInputsTypes = (typeof CREATE_STORE_INPUTS_TYPES)[keyof typeof CREATE_STORE_INPUTS_TYPES]

export const CreateStoreScreen = ({ route }) => {
    const schedule_id = route?.params?.schedule_id
    const distributor_id = route?.params?.distributor_id
    const { form, onChange } = useForm({})
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const navigation = useNavigation()

    const {
        fields,
        provinces,
        setSelectedProvince,
        citys,
        handleSaveStore,
        isValidFieldsForms,
        getDataFields,
        setIsVisibleFormOrganization,
        isVisibleFormOrganization,
        optionsOrganizations,
        getLocation,
        loading,
    } = useCreatePos()
    const [invalidFieldsArray, setInvalidFields] = useState([])
    const [sending, isSending] = useState(false)
    
    const isFormValid = useMemo(() => {
        if (!fields || fields.length === 0) return false
        
        const requiredFields = fields.filter(field => {

            if (!field.required) return false
            
            if (isVisibleFormOrganization) {
                // Creando nueva organización: excluir el dropdown
                if (field.name === 'organization') return false
                // Los campos de nueva org se validan normalmente (organization_field = true)
            } else {
                // Seleccionando org existente: excluir campos de nueva organización
                if (field.organization_field === true) return false
            }
            
            // Validar dependencias
            const hasValidDependency = field.dependency && 
                                      field.dependency !== '' && 
                                      field.dependency !== '0' && 
                                      field.dependency !== 0
            
            if (hasValidDependency) {
                const dependencyKey = Object.keys(form).find(key => key === field.dependency)
                if (dependencyKey === undefined) return false // Campo bloqueado por dependencia
            }
            
            return true
        })

        // console.log('📝 Campos requeridos para validación:', requiredFields.map(f => f.name))
        
        // Verificar que todos los campos requeridos tengan valor
        const allRequiredFieldsFilled = requiredFields.every(field => {
            const value = form[field.name]
            const isFilled = value !== undefined && value !== null && value !== ''
            if (!isFilled) {
                console.log(`❌ Campo sin completar: ${field.name}`)
            }
            return isFilled
        })

        // console.log('✅ Validación de formulario - ¿Todos los campos requeridos están completos?', allRequiredFieldsFilled)
        
        return allRequiredFieldsFilled
    }, [fields, form, isVisibleFormOrganization])
    
    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            console.log('------CreateStoreScreen - focus-----------')
            getDataFields()
            getAddress()
            // handleGetDataLocation()
        })

        return unsubscribe
    }, [navigation])
    const startLoader = () => eventEmitter.emit('starGeneralLoader')
    const endLoader = () => eventEmitter.emit('endGeneralLoader')

    function loader(start: boolean) {
        if (start) {
            startLoader()
            isSending(true)
        } else {
            endLoader()
            isSending(false)
        }
    }
    const getAddress = async () => {
        try {

            if (fields == null || fields.length === 0) {
                console.warn('getAddress - No hay campos definidos aún')
                return
            }

            if (fields.some((field) => field.name === 'address') === false) {
                console.warn('getAddress - No hay campo de dirección definido - no hace falta buscar address')
                return
            }
            const hasConnection = await validateConnectionNetwork()

            if (!hasConnection) {
                return
            }
            const { lat, lng } = await getLocation()
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""

            const res = await request_get_address({ authToken, lat, lng })
            if (res && res.status === 1 && res.single && res.single.address && res.single.address !== '') {
                const address = res.single.address
                onChange(address, 'address')
            }
        } catch (error) {
            console.log('error', error)
        }
    }
    const setSelectedDependency = (name: string, value: string) => {
        if (name === 'provinces') {
            let selectedProvince = provinces.find((province) => province._id === value)
            setSelectedProvince(selectedProvince)
        }
    }
    const openIncompleteFormModal = (message) => {
        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/stores/existingStore.png')}
                title={'Campos incompletos'}
                desc={message}
                button={'Aceptar'}
                closeBottomSheet={() => {
                    closeBottomSheet(true)
                }}
            />,
            false,
            false,
            false,
        )
    }

    const sendForm = async (form) => {
        // setInvalidFields([])
        if (sending) {
            return
        }
        loader(true)
        try {
            let { formValid, message, invalidFields } = await isValidFieldsForms(form, isVisibleFormOrganization)
            if (invalidFields.length > 0) {
                // openIncompleteFormModal(message)
                setInvalidFields(invalidFields)
                loader(false)
                return
            } else {
                setInvalidFields([])
            }
            let validate_unique = fields
                .map((field) => {
                    if (field.validate_unique && field.validate_unique === true) {
                        return { label_id: field._id, label: field.name, table: field.table, value: form[field.name] }
                    }
                    return null
                })
                .filter((item) => item !== null)

            let newForm = { ...form, schedule_id, validate_unique: validate_unique }
            let status = await handleSaveStore(newForm, isVisibleFormOrganization, distributor_id)
            loader(false)
            // console.log('1status ===> ', JSON.stringify(status))
            // console.log('2status ===> ', status)
            // console.log('3status ===> ', typeof status)

            let image = require('../../../assets/stores/inactiveVespertino.png')
            let title = 'Tienda creada con éxito'
            let desc = 'Veras la tienda en la lista de ruta'
            let button = 'Aceptar'

            if (!status || status === 0) {
                image = require('../../../assets/stores/existingStore.png')
                title = 'Hubo un error al crear la tienda'
                desc = 'Por favor, vuelve a intentar'
            }
            if (status === -1) {
                image = require('../../../assets/stores/existingStore.png')
                title = 'Tienda existente.'
                desc = 'Si el nombre, la razón social o el CUIT ya están registrados, no se crearán nuevamente. Asegurate de revisar cuidadosamente la información antes de completar el registro de la tienda.'
            }
            const isModalClosable = false
            const isModalClosableTouch = false
            const isModalClosableSlice = false
            openBottomSheet(
                <BottomSheetAlert
                    image={image}
                    title={title}
                    desc={desc}
                    button={button}
                    closeBottomSheet={() => {
                        closeBottomSheet(true)
                        if (!status || status === 0 || status === -1) {
                            return
                        }
                        navigation.goBack()
                    }}
                />,
                isModalClosable,
                isModalClosableTouch,
                isModalClosableSlice,
            )
            return
        } catch (error) {
            console.log('error', error)
            loader(false)
            return
        }
    }
    const renderCreatePosFields = ({ item, index, error = null }) => {
        let options = []
        
        // 🔍 DEBUG: Mostrar información del campo
        // console.log(`📝 Campo ${index} - "${item.name}":`, {
        //     dependency: item.dependency,
        //     optionsFrom: item.optionsFrom,
        //     type: item.type,
        //     required: item.required
        // })

        /* 
            {
        "_id": "683089294ea4ee6aecf323fb", 
        "configure": 0, 
        "dependency": "0", 
        "name": "name", 
        "options": [], 
        "optionsFrom": "0", 
        "placeholder": "Nombre de la tienda", 
        "required": true, 
        "table": "pos", 
        "title": "Elige nombre", 
        "type": "text", 
        "validate_unique": true
        }
        */
        const hasValidOptionsFrom = item.optionsFrom && item.optionsFrom !== '' && item.optionsFrom !== '0' && item.optionsFrom !== 0
        
        if (hasValidOptionsFrom) {
            let optionFrom = item.optionsFrom
            if (optionFrom === 'provinces') {
                options = provinces.sort((a, b) => a.name.localeCompare(b.name))
            }
            if (optionFrom === 'citys') {
                options = citys.sort((a, b) => a.name.localeCompare(b.name))
            }
            if (optionFrom === 'fields_organization') {
                //options = item.options
                options = optionsOrganizations
            }
        } else {
            options = item.options
        }
        
        let canAnswer = true
        const hasValidDependency = item.dependency && item.dependency !== '' && item.dependency !== '0' && item.dependency !== 0
        
        if (hasValidDependency) {
            let dependency = item.dependency
            let l = Object.keys(form).find((key) => key === dependency)
            if (l === undefined) {
                canAnswer = false
            }
        }

        // console.log(`✅ Campo "${item.name}" - canAnswer: ${canAnswer}`)

        // console.log(`${index} - item`, item)

        return (
            <CreatePosFields
                item={item}
                key={index}
                onChange={(value) => onChange(value, item.name)}
                options={options}
                setSelectedDependency={setSelectedDependency}
                canAnswer={canAnswer}
                handleCreateOrganization={handleCreateOrganization}
                isVisibleFormOrganization={isVisibleFormOrganization}
                initialValue={form[item.name]}
                error={error}
            />
        )
    }
    const handleCreateOrganization = () => {
        const newState = !isVisibleFormOrganization
        setIsVisibleFormOrganization(newState)
        
        if (newState) {
            onChange(null, 'organization')
            console.log('🔄 Modo: Crear nueva organización - dropdown limpiado')
        } else {
            onChange(null, 'organization_name')
            onChange(null, 'organization_cuit')
            console.log('🔄 Modo: Seleccionar organización existente - campos de nueva org limpiados')
        }
    }
    if (loading) {
        return <Loader />
    }
    return (
        <View style={{ flex: 1, backgroundColor: 'white' }}>
            <Text style={{ fontSize: 20, fontWeight: '500', marginHorizontal: 12, marginTop: 12 }}>Estás creando una nueva tienda</Text>
            <Text style={{ fontWeight: '300', fontSize: 15, marginTop: 4, marginHorizontal: 12 }}>
                Debes completar todos los campos obligatorios (*) para crear una nueva tienda
            </Text>

            <ScrollView>
                <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>
                    <View style={styles.containerView}>
                        {fields && fields.length > 0 && fields.map((item, index) => {
                            let error = invalidFieldsArray.find((field) => field._id === item._id)
                            return renderCreatePosFields({ item, index, error })
                        })}
                        <View style={{ height: 20 }} />
                    </View>
                </TouchableWithoutFeedback>
            </ScrollView>

            <TouchableOpacity
                style={{
                    height: 40,
                    borderRadius: 10,
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginHorizontal: 12,
                    marginBottom: !isFormValid && !sending ? 8 : (isIOS() ? 30 : 15),
                    backgroundColor: (!isFormValid || sending) ? theme.colors.mediumGray : theme.colors.colorPrimary,
                    opacity: (!isFormValid || sending) ? 0.6 : 1,
                }}
                onPress={() => sendForm(form)}
                disabled={!isFormValid || sending}
            >
                <Text
                    style={{
                        fontSize: 15,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}
                >
                    {sending ? 'Creando...' : 'Crear tienda'}
                </Text>
            </TouchableOpacity>

            <View style={{ height: 20 }} />

        </View>
    )
}

const defaultConfig = {
    keyboard: undefined,
    maxLength: undefined,
    minLength: 0,
    format: '', // ""
}

const CreatePosFields = ({
    item,
    onChange,
    options,
    setSelectedDependency,
    canAnswer,
    handleCreateOrganization,
    isVisibleFormOrganization,
    initialValue,
    error,
}: {
    item: any
    onChange: (value: any) => void
    options: Option[]
    setSelectedDependency: (name: string, value: string) => void
    canAnswer?: boolean
    handleCreateOrganization: () => void
    isVisibleFormOrganization: boolean
    initialValue: string | { _id: string; [key: string]: any } | null
    error: { _id: string; message: string } | null
}) => {
    const [selectedValue, setSelectedValue] = useState()
    const [text, setText] = useState(
        typeof initialValue === 'string' ? initialValue : 
        initialValue && typeof initialValue === 'object' ? '' : 
        ''
    )
    const [errorMessage, setErrorMessage] = useState(null)
    useEffect(() => {
        if (error) {
            setErrorMessage(error)
        } else {
            setErrorMessage(null)
        }
    }, [error])
    const config = item.configure || defaultConfig

    const optionsData = useMemo(() => {
        if (!options) {
            return []
        }
        return options.map((option) => ({
            key: option._id,
            value: option.name,
        }))
    }, [options])

    // ✅ Calcular defaultOption para mostrar el valor seleccionado visualmente
    const defaultOption = useMemo(() => {
        if (!initialValue || !optionsData || optionsData.length === 0) {
            return undefined
        }
        
        // Si initialValue es un objeto con _id
        if (typeof initialValue === 'object' && initialValue._id) {
            const found = optionsData.find(opt => opt.key === initialValue._id)
            return found ? found.key : undefined
        }
        
        // Si initialValue es un string (ID directo)
        if (typeof initialValue === 'string') {
            const found = optionsData.find(opt => opt.key === initialValue)
            return found ? found.key : undefined
        }
        
        return undefined
    }, [initialValue, optionsData])

    useEffect(() => {
        if (initialValue && typeof initialValue === 'string' && text === '') {
            setText(initialValue)
        }
    }, [initialValue])

    const onChangeDropdown = (value: string) => {
        if (optionsData.length === 0) return
        // options = []
        if (item.optionsFrom != null && item.optionsFrom != '') {
            let optionFrom = item.optionsFrom
            if (optionFrom === 'provinces') {
                //Sumar provincia seleccionada
                setSelectedDependency('provinces', value)
            }
            if (optionFrom === 'citys') {
                //Sumar ciudad seleccionada
                setSelectedDependency('citys', value)
            }
        }
        // console.log("'options', options", options)
        const selectedOption = options.find((option) => option._id === value)
        onChange(selectedOption)
        setErrorMessage(null)
    }
    const onChangeText = (value: string) => {
        let newValue = value
        setText(newValue)
        // Se formatea el texto previo al guardado para evitar despases de formato
        let formattedText = formatValue(newValue)
        onChange(formattedText)
        setErrorMessage(null)
    }
    const formatValue = (raw) => {
        let formatted = raw
        if (config.format === 'cuit') {
            const digits = raw.replace(/\D/g, '').slice(0, 11)
            if (digits.length <= 2) {
                formatted = digits
                return formatted
            }
            if (digits.length <= 10) {
                formatted = `${digits.slice(0, 2)}-${digits.slice(2)}`
                return formatted
            }
            formatted = `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`
            return formatted
        }
        return formatted
    }
    if (item.organization_field && item.organization_field === true && !isVisibleFormOrganization) {
        return <></>
    }
    
    // ✅ Bloquear dropdown de "organization" cuando se está creando nueva organización
    const isOrganizationDropdown = item.optionsFrom === 'fields_organization'
    const shouldDisableOrganizationDropdown = isOrganizationDropdown && isVisibleFormOrganization
    
    const dropDownStyle = StyleSheet.create({
        input: {
            flex: 1,
            width: 'auto',
            height: 40,
            borderWidth: 1,
            borderRadius: 5,
            borderColor: errorMessage ? 'red' : theme.colors.lightGray,
            paddingVertical: 0,
            paddingHorizontal: 10,
            marginHorizontal: 0,
            marginBottom: 0,
            alignItems: 'center',
            color: theme.colors.textPrimary,
            opacity: shouldDisableOrganizationDropdown ? 0.5 : 1,
        },
    })
    return (
        <View style={[{ 
            flex: 1, 
            pointerEvents: !canAnswer ? 'none' : null, 
            opacity: !canAnswer ? 0.5 : 1, 
            marginTop: 20 
        }]}>
            <Text style={{ fontWeight: '700', fontSize: 16, marginBottom: 5 }}>{item.title + (item.required === true ? '*' : '')}</Text>
            {(() => {
                switch (item.type as CreateStoreInputsTypes) {
                    case CREATE_STORE_INPUTS_TYPES.DROPDOWN:
                        return (
                            <View>
                                <View
                                    style={{
                                        flexDirection: 'row',
                                    }}
                                >
                                    <View style={{ 
                                        flex: 1,
                                        pointerEvents: shouldDisableOrganizationDropdown ? 'none' : 'auto',
                                        opacity: shouldDisableOrganizationDropdown ? 0.5 : 1
                                    }}>
                                        <SelectList
                                            key={
                                                initialValue && typeof initialValue === 'object' && '_id' in initialValue
                                                    ? initialValue._id
                                                    : typeof initialValue === 'string' 
                                                    ? initialValue 
                                                    : 'reset'
                                            }
                                            placeholder={'--Seleccionar--'}
                                            maxHeight={optionsData.length > 10 ? 200 : 10000}
                                            data={optionsData}
                                            save='key'
                                            defaultOption={defaultOption ? { key: defaultOption, value: optionsData.find(o => o.key === defaultOption)?.value } : undefined}
                                            search={optionsData.length > 10 ? true : false}
                                            searchPlaceholder='Buscar...'
                                            arrowicon={<Feather name={'chevron-down'} size={22} color={theme.colors.colorPrimary} />}
                                            boxStyles={dropDownStyle.input}
                                            dropdownStyles={styles.dropdown}
                                            dropdownTextStyles={styles.dropdownOptions}
                                            inputStyles={styles.dropdownInputSelected}
                                            setSelected={(value) => onChangeDropdown(value)}
                                        />
                                    </View>
                                    {item.optionsFrom == 'fields_organization' && (
                                        <TouchableOpacity
                                            onPress={handleCreateOrganization}
                                            style={{
                                                width: 40,
                                                height: 40,
                                                backgroundColor: theme.colors.colorPrimary,
                                                borderRadius: 20,
                                                marginStart: 12,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Feather name={isVisibleFormOrganization ? 'minus' : 'plus'} size={24} color={'white'} />
                                        </TouchableOpacity>
                                    )}
                                </View>
                            </View>
                        )
                    case CREATE_STORE_INPUTS_TYPES.TEXT:
                        return (
                            <TextInput
                                style={[styles.input, { fontSize: 14 }, errorMessage && { borderColor: 'red' }]}
                                placeholder={item.placeholder || 'Completa el dato'}
                                value={formatValue(text)}
                                placeholderTextColor={theme.colors.mediumGray}
                                autoCorrect={false}
                                onChangeText={(value) => onChangeText(value)}
                                autoCapitalize='none'
                                keyboardType={config.keyboard || 'default'}
                                maxLength={config.maxLength}
                            />
                        )
                    case CREATE_STORE_INPUTS_TYPES.NUMBER:
                        return (
                            <TextInput
                                style={[styles.input, { fontSize: 14 }, errorMessage && { borderColor: 'red' }]}
                                placeholder={item.placeholder || 'Completa el dato'}
                                value={formatValue(text)}
                                placeholderTextColor={theme.colors.mediumGray}
                                autoCorrect={false}
                                onChangeText={(value) => onChangeText(value)}
                                autoCapitalize='none'
                                keyboardType={config.keyboard || 'default'}
                                maxLength={config.maxLength}
                            />
                        )
                    default:
                        return (
                            <View>
                                <Text>Hubo un error</Text>
                            </View>
                        )
                }
            })()}
            {errorMessage && errorMessage != undefined && (
                <Text style={{ color: 'red', marginTop: 3, marginStart: 1, fontSize: 12 }}>{errorMessage.message}</Text>
            )}
        </View>
    )
}

interface Option {
    _id: string
    name: string
}
interface PropsCustomSwtich {
    // isOn: boolean
    placeholder: string
    onChange: (value: boolean) => void
}

export const CustomSwtich = ({ onChange, placeholder }: PropsCustomSwtich) => {
    const [isEnabled, setIsEnabled] = useState(false)

    const toggleSwitch = () => {
        setIsEnabled(!isEnabled)
        onChange(!isEnabled)
    }

    return (
        <View>
            {placeholder && <Text>{placeholder}</Text>}
            <Text>isEnabled: {JSON.stringify(isEnabled)}</Text>
            <Switch onValueChange={toggleSwitch} value={isEnabled} />
        </View>
    )
}
const styles = StyleSheet.create({
    containerView: {
        marginHorizontal: 12,
    },
    input: {
        flex: 1,
        width: 'auto',
        height: 40,
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 0,
        paddingHorizontal: 10,
        marginHorizontal: 0,
        marginBottom: 0,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputDropdownMenuSubsection: {
        borderWidth: 0.2,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        fontSize: 15,
        color: theme.colors.mediumGray,
    },
    selectedContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginVertical: 8,
        marginHorizontal: 12,
    },
    dropdown: {
        borderWidth: 0.2,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.lightGray,
        marginTop: -5,
        marginHorizontal: 12,
        marginBottom: 5,
    },
    dropdownInputSelected: {
        fontSize: 14,
        color: theme.colors.textPrimary,
    },
})
